import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTriangleDownRed = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 14,
	height: 14,
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M4.6 5.83785C4.6486 5.88855 4.70967 5.92939 4.77883 5.95742C4.84799 5.98546 4.92352 6 5 6C5.07648 6 5.15202 5.98546 5.22118 5.95742C5.29034 5.92939 5.35141 5.88855 5.4 5.83785L9.9 0.686806C9.95571 0.623032 9.98964 0.547199 9.99798 0.467803C10.0063 0.388408 9.98874 0.308587 9.94721 0.237285C9.90569 0.165984 9.84185 0.106019 9.76287 0.0641087C9.68388 0.0221987 9.59286 2.52927e-08 9.5 2.52927e-08L0.500001 2.52927e-08C0.407145 2.52927e-08 0.316123 0.0221987 0.237135 0.0641087C0.158147 0.106019 0.0943145 0.165984 0.052788 0.237285C0.0112616 0.308587 -0.00631791 0.388408 0.00202107 0.467803C0.0103601 0.547199 0.044288 0.623032 0.100002 0.686806L4.6 5.83785Z",
		fill: "#D04246"
	})
});
export default SvgTriangleDownRed;
